export default "__VITE_ASSET__l7WIohze__"